<template>
  <div class="ml-5 mr-5">
    <div class="text-center">
      <loading
        :active.sync="isLoaderVisible"
        :can-cancel="false"
        loader="dots"
        color="#007bff"
        :height="45"
        :width="75"
        :is-full-page="true"
      ></loading>
    </div>
    
    <div class="text-left">
      <v-container fluid>
        <v-row class="no-gutters">
          <v-col
            cols="3"
            offset="9"
            class="text-right mt-5"
          >
            <v-btn
              class="mr-4"
              color="primary"
              small
              :disabled="isParticipationsLoading"
              :loading="isParticipationsLoading"
              v-show="checkIfOperationExistForModule('view')"
              @click="fetchParticipations"
            >
              Show Participations
            </v-btn>

            <v-btn
              color="primary"
              class="mr-0"
              small
              v-show="checkIfOperationExistForModule('add')"
              @click="handleAddRecord"
            >
              Add
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col>
            <div class="tableWrapper">
              <v-data-table
                :loading="isLoading"
                :headers="headers"
                :items="items"
                item-key="year"
                :page.sync="page"
                :options.sync="options"
                class="elevation-1"
                :server-items-length="totRecords"
                hide-default-footer
                @page-count="pageCount = $event"
              >
                <template v-slot:item.actions="{ item }">
                  <v-row class="no-gutters">
                    <v-col class="text-left">
                      <v-icon
                        class="mr-4"
                        @click="handleEditRecord(item)"
                        title="Edit"
                        v-show="checkIfOperationExistForModule('edit')"
                        >mdi-pencil</v-icon
                      >
                      <v-icon
                        @click="handleDeleteRecord(item)"
                        title="Delete"
                        v-show="checkIfOperationExistForModule('delete')"
                        >mdi-delete</v-icon
                      >
                    </v-col>
                  </v-row>
                </template>
                <template v-slot:top>
                  <v-dialog
                    v-if="multiplierForm.isOpen"
                    v-model="multiplierForm.isOpen"
                    persistent
                    max-width="800px"
                  >
                    <v-card elevation="1" max-height="900px">
                      <v-toolbar flat dense color="primary">
                        <v-spacer></v-spacer>
                        <v-toolbar-title
                          ><span style="color: white">{{
                            multiplierForm.name
                          }}</span></v-toolbar-title
                        >
                        <v-spacer></v-spacer>
                        <div class="text-right pa-2">
                          <v-icon
                            v-show="isLoading === false"
                            color="white"
                            @click="closeMultiplierDialog()"
                          >
                            mdi-close
                          </v-icon>
                        </div>
                      </v-toolbar>
                      <v-form ref="form" @submit.prevent="
                        handleMultiplierFormSubmit();
                      " method="post" enctype=multipart/form-data>
                        <v-card-text>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.year"
                                :items="yearOptions" 
                                item-text="val"
                                item-value="db_val"
                                label="Year*"
                                chips
                                small-chips
                                return-object
                                :rules="yearRules"
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.month"
                                :items="monthOptions" 
                                item-text="val"
                                item-value="db_val"
                                label="Month*"
                                chips
                                small-chips
                                return-object
                                :rules="monthRules"
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.mediaChannel"
                                :items="mediaChannelOptions.data"
                                :loading="mediaChannelOptions.isLoading"
                                item-text="val"
                                item-value="db_val"
                                label="Media Channel"
                                chips
                                small-chips
                                return-object
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.primarySector"
                                :items="sectorOptions.data"
                                :loading="allSectors.isLoading"
                                item-text="val"
                                item-value="db_val"
                                label="Primary Sector*"
                                chips
                                small-chips
                                return-object
                                :rules="sectorRules"
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                              <!-- @change="getSubCat()" -->
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.primaryCategory"
                                :items="categoryOptions.data"
                                :loading="allSectors.isLoading"
                                item-text="val"
                                item-value="db_val"
                                label="Primary Category*"
                                chips
                                small-chips
                                return-object
                                :rules="categoryRules"
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                              <!-- @change="getSubCat()" -->
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.primarySubCategory"
                                :items="subCategoryOptions.data"
                                :loading="allSectors.isLoading"
                                item-text="val"
                                item-value="db_val"
                                label="Primary Sub Category"
                                chips
                                small-chips
                                return-object
                                persistent-hint
                                style="font-size: 14px"
                              >
                              </v-select>
                            </v-col>
                            <v-col>
                              <v-autocomplete
                                v-model="multiplierForm.values.company"
                                :items="companySearch.data"
                                item-text="val"
                                item-value="db_val"
                                label="Company"
                                :loading="companySearch.isLoading"
                                :search-input.sync="companySearch.query"
                                hide-no-data
                                hide-selected
                                placeholder="Enter minimum 2 characters"
                                prepend-icon="mdi-magnify"
                                deletable-chips
                                chips
                                small-chips
                                return-object
                              ></v-autocomplete>
                            </v-col>
                            <v-col>
                              <v-select
                                v-model="multiplierForm.values.country"
                                :items="countryOptions.data"
                                :loading="countryOptions.isLoading"
                                :rules="countryRules"
                                item-text="val"
                                item-value="db_val"
                                label="Country*"
                                return-object
                                chips
                                small-chips
                                persistent-hint
                                style="font-size: 14px"
                              />
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="3">
                              <v-text-field
                                v-model="multiplierForm.values.multiplier"
                                label="Multiplier*"
                                type="number"
                                chips
                                small-chips
                                :min="0"
                                :max="999999"
                                :rules="multiplierRules"
                              >
                              </v-text-field>
                            </v-col>
                          </v-row>
                        </v-card-text>
                        <v-card-actions class="justify-end">
                          <v-spacer></v-spacer>
                          <v-btn type="submit" small color="primary">
                            save
                          </v-btn>
                          <v-btn color="grey" small @click="
                            closeMultiplierDialog()
                            ">
                            cancel
                          </v-btn>

                        </v-card-actions>
                      </v-form>
                    </v-card>
                  </v-dialog>
                </template>
              </v-data-table>
              <div class="text-center pt-4 pb-4">
                <Pagination
                  :isloading="isLoading"
                  :startRecord="startRecord"
                  :currentPage="currentPage"
                  :lastPage="lastPage"
                  :lastRecord="lastRecord"
                  :totRecords="totRecords"
                  :isCurrentPageClass="isCurrentPageClass"
                  :perpage="perpage"
                  :getLastPageClass="getLastPageClass"
                  :totPage="totPage"
                  :getPages="getPages"
                  @handlePerPage="handlePerPage"
                  @paginate="paginate"
                  @last="last"
                  @getDataByPage="getDataByPage"
                  :showPerPage="true"
                />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-dialog
          v-model="isParticipationsDialogOpen"
          persistent
          max-width="1000px"
          max-height="auto"
        >
          <v-container style="background-color: white" fluid>
            <v-toolbar flat dense>
              <v-tabs v-model="participationsTabName" color="primary" grow slider-size="2">
                <v-tab v-for="(item, index) in participationsTabItems" :key="index">{{
                  item.tab
                }}</v-tab>
              </v-tabs>
              <v-spacer></v-spacer>
              <v-icon color="primary" @click="isParticipationsDialogOpen = false">
                mdi-close
              </v-icon>
            </v-toolbar>
            <v-row>
              <v-col cols="1" md="1"> </v-col>
              <v-col cols="10" md="10">
                <v-tabs-items v-model="participationsTabName">
                  <v-tab-item v-for="(item, index) in participationsTabItems" :key="index">
                    <v-card elevation="1" max-height="auto" max-width="auto">
                      <v-data-table
                        elevation="1"
                        class="mb-12"
                        :loading="isLoading"
                        :headers="item.headers"
                        :items="item.items"
                        :server-items-length="13"
                        hide-default-footer
                        item-key="date"
                      >
                        <template v-slot:top>
                          <v-toolbar flat dense>
                            <v-spacer></v-spacer>
                            <v-toolbar-title
                              ><span>{{ item.tab }}</span></v-toolbar-title
                            >
                            <v-spacer></v-spacer>
                          </v-toolbar>
                        </template>
                      </v-data-table>
                      <v-spacer></v-spacer>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </v-col>
              <v-col cols="1" md="1"> </v-col>
            </v-row>
          </v-container>
        </v-dialog>
      </v-container>
      <v-dialog v-model="isConfirmDeleteDialogOpen" persistent max-width="400px">
        <v-card>
          <v-card-title class="text-h4 pa-16">
            <b>Do you really want to delete record?</b>
          </v-card-title>

          <v-card-actions class="justify-end">
            <v-spacer></v-spacer>
            <v-btn small color="primary" @click="deleteRecord()"> Yes </v-btn>
            <v-btn color="grey" small @click="isConfirmDeleteDialogOpen = false">
              Close
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import Pagination from "./component/Pagination.vue";

export default {
  components: { Loading, Pagination },
  data(){
    return {     
      items: [],
      options: {},
      isLoading: true,
      //pagination code
      page: 1,
      pageCount:0,
      perpage: 10,
      totRecords: 0,

      isParticipationsLoading: false,
      isParticipationsDialogOpen: false,
      participationsTabName: null,

      itemToDelete: null,
      isConfirmDeleteDialogOpen: false,

      itemToUpdate: null,
      isLoadEditRecord: true,

      multiplierForm: {
        name: "",
        isOpen: false,
        isLoading: false,
        values: {
          year: null,
          month: null,
          mediaChannel: null,
          primarySector: null,
          primaryCategory: null,
          primarySubCategory: null,
          company: null,
          country: null,
          multiplier: 0.0,
        },
      },
      companySearch: {
        data: [],
        query: '',
        isLoading: false,
        debounce: null,
      },
      mediaChannelOptions: {
        isLoading: false,
        data: []
      },
      countryOptions: {
        isLoading: false,
        data: []
      },
      allSectors: {
        isLoading: false,
        data: []
      },
      sectorOptions: {
        data: []
      },
      categoryOptions: {
        data: []
      },
      subCategoryOptions: {
        data: []
      },
      
      participationsTabItems: [
        {
          tab: "Direct Mail Panelist Participations",
          headers: [
            {
              text: "Date",
              value: "date",
              sortable: false,
              width: "60",
              class: "v-data-table-header",
            },
            {
              text: "Consumer",
              value: "consumer",
              sortable: false,
              width: "60",
              class: "v-data-table-header",
            },
            {
              text: "Employer/Business Owner",
              value: "business",
              sortable: false,
              width: "150",
              class: "v-data-table-header",
            },
            {
              text: "Insurance Producer/Financial Advisor",
              value: "insurance",
              sortable: false,
              width: "150",
              class: "v-data-table-header",
            },
          ],
          items: [],
        },
        {
          tab: "Electronic Mail Panelist Participations",
          headers: [
            {
              text: "Date",
              value: "date",
              sortable: false,
              width: "60",
              class: "v-data-table-header",
            },
            {
              text: "Consumer",
              value: "consumer",
              sortable: false,
              width: "60",
              class: "v-data-table-header",
            },
            {
              text: "Employer/Business Owner",
              value: "business",
              sortable: false,
              width: "150",
              class: "v-data-table-header",
            },
            {
              text: "Insurance Producer/Financial Advisor",
              value: "insurance",
              sortable: false,
              width: "150",
              class: "v-data-table-header",
            },
          ],
          items: [],
        },
      ],

      yearRules: [
        (v) => {
          return !!v?.val || "Select year"
        },
      ],
      monthRules: [
        (v) => {
          return !!v?.val || "Select month"
        },
      ],
      sectorRules: [
        (v) => {
          return !!v?.val || "Select Primary Sector"
        },
      ],
      categoryRules: [
        (v) => {
          return !!v?.val || "Select Primary Category"
        },
      ],
      countryRules: [
        (v) => {
          return !!v?.val || "Select Country"
        },
      ],
      multiplierRules: [
        (val) => val < 999999 || "Max value should be less than 999999",
        (val) => val != null || "Value Required",
        (val) => val != '' || "Value Required",
        (val) => val >= 0 || "Negative is not valid",
        function (val) {
          if (val != null) {
            let check = val.toString();
            if(check.length > 7){
              return "Total length should be less than 7"
            }
            check = check.split(".");
            if (check.length > 1) {
              return (
                check[1].length < 4 || "Only three digits after decimal required"
              );
            }
          }
          return true;
        },
      ],
      headers: [
        {
          text: "Year",
          value: "m_year",
          sortable: false,
          width: "60",
          class: "v-data-table-header",
        },
        {
          text: "Month",
          value: "m_month",
          sortable: false,
          width: "60",
          class: "v-data-table-header",
        },
        {
          text: "Media Channel",
          value: "mChannelName",
          sortable: false,
          width: "140",
          class: "v-data-table-header",
        },
        {
          text: "Primary Sector",
          value: "s1_sectorName",
          sortable: false,
          width: "140",
          class: "v-data-table-header",
        },
        {
          text: "Primary Category",
          value: "s2_sectorName",
          sortable: false,
          width: "160",
          class: "v-data-table-header",
        },
        {
          text: "Primary Sub Category",
          value: "s3_sectorName",
          sortable: false,
          width: "180",
          class: "v-data-table-header",
        },
        {
          text: "Company",
          value: "companyName",
          sortable: false,
          width: "120",
          class: "v-data-table-header",
        },
        {
          text: "Country",
          value: "countryName",
          sortable: false,
          width: "120",
          class: "v-data-table-header",
        },
        {
          text: "Multiplier",
          value: "multiplier",
          sortable: false,
          width: "120",
          class: "v-data-table-header",
        },
        {
          text: "Actions",
          value: "actions",
          sortable: false,
          width: "120",
          class: "v-data-table-header",
        },
      ],
    };
  },
  computed: {
    isLoaderVisible() {
      return this.isLoading || this.multiplierForm.isLoading;
    },

    //pagination computed methods
    startRecord: function () {
      return parseInt(this.lastRecord) - parseInt(this.perpage) + parseInt(1);
    },
    lastRecord: function () {
      return this.perpage * this.currentPage;
    },
    isCurrentPageClass: function () {
      return this.currentPage === 1 ? "" : "notactivespan";
    },
    getLastPageClass: function () {
      return parseInt(this.lastPage) === parseInt(this.currentPage)
        ? ""
        : "notactivespan";
    },
    totPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    getPages: function () {
      return this.$utils.getPages(
        this.lastPage,
        this.currentPage,
        this.totPage
      );
    },
    currentPage: function () {
      return this.page;
    },
    lastPage: function () {
      return Math.ceil(parseInt(this.totRecords) / parseInt(this.perpage));
    },
    endIndex: function () {
      if (this.page == 1) {
        return this.perpage;
      } else {
        return this.perpage * this.page;
      }
    },
    startIndex: function () {
      if (this.page == 1) {
        return this.perpage * 0;
      } else {
        return this.endIndex - this.perpage;
      }
    },
    yearOptions() {
      const currentYear = new Date().getFullYear();
      const years = [{ db_val: 0, val: "All" }];

      for (let year = 2009; year <= currentYear; year++) {
        years.push({ db_val: year, val: year });
      }

      return years;
    },

    monthOptions() {
      const months = [{ db_val: 0, val: "All" }];
      const monthNames = moment.months(); // e.g., ["January", "February", ...]

      monthNames.forEach((month, index) => {
        months.push({ db_val: index + 1, val: month });
      });

      return months;
    },
  },
  
  watch: {
    page() {
      this.fetchReports();
    },
    'companySearch.query'(query) {
      if (!query || query.length < 2 || this.isLoading || this.companySearch.isLoading) return;
      this.companySearch.data = [];
      clearTimeout(this.companySearch.debounce);
      this.companySearch.debounce = setTimeout(async () => {
        const compUrl = this.$url("admin_report_url") + "get_companies";
        const payload = { message: query };
        this.companySearch.isLoading = true;
        try {
          const res = await this.$fetch({ requiresAuth: true, operation: "add", vueScope: this }).post(compUrl, payload);
          this.companySearch.data = res.data.companies || [];
        } catch (error) {
          console.error(error);
        } finally {
          this.companySearch.isLoading = false;
        }
      }, 300);
    },
    'multiplierForm.values.primarySector'(sectorOption) {
      if (!this.isLoadEditRecord){ // prevent resetting on edit
        this.multiplierForm.values.primaryCategory = null
        this.multiplierForm.values.primarySubCategory = null
      }
      this.categoryOptions.data = []
      this.subCategoryOptions.data = []
      const categoriesData = this.allSectors.data?.find(item=>item.id===sectorOption?.db_val)
      this.categoryOptions.data = this.generateDropdownOptions(categoriesData?.children)
    },
    'multiplierForm.values.primaryCategory'(categoryOption) {
      if (!this.isLoadEditRecord){ // prevent resetting on edit
        this.multiplierForm.values.primarySubCategory = null
      }
      const sectorOption = this.multiplierForm.values.primarySector
      this.subCategoryOptions.data = []
      const categoriesData = this.allSectors.data?.find(item=>item.id===sectorOption?.db_val)
      const subCategoriesData = categoriesData?.children?.find(item=>item.id===categoryOption?.db_val)
      this.subCategoryOptions.data = this.generateDropdownOptions(subCategoriesData?.children)
    }
  },
  
  methods: {
    //pagination methods
    getDataByPage(value) {
      this.page = value;
    },
    handlePerPage(value) {
      this.perpage = value;
      if(this.page!==1){
        this.page = 1;
      }else{
        this.fetchReports();
      }
    },
    paginate(n) {
      if(n==0){
        // First page
        this.page = 1
      }else{
        const nextPage = this.page + n;
        this.page = Math.min(Math.max(1, nextPage), this.pageCount)
      }
    },
    last() {
      this.page = this.lastPage;
    },
    generateDropdownOptions(list){
      if(!list) return []
      return list.map(({id, name})=>({db_val: id, val: name }));
    },

    async fetchReports() {
      let mail_vol_url = this.$url("admin_report_url") + "get_mail_volume_report";

      this.isLoading = true;
      let data = {
        page: this.page,
        per_page: this.perpage,
      };
      try {
        const res = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).post(mail_vol_url, data);
        this.items = res.data?.report;
        this.totRecords = res.data?.total_items || 0;
        this.pageCount = res.data?.total_pages || 0;
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },

    async openMultiplierDialog() {
      this.multiplierForm.isOpen = true;
      const promises = [];
      if (!this.mediaChannelOptions.data?.length) {
        promises.push(this.fetchMediaChannels());
      }
      if (!this.countryOptions.data?.length) {
        promises.push(this.fetchCountries());
      }
      if (!this.allSectors.data?.length) {
        promises.push(this.fetchAllSectors());
      }
      await Promise.all(promises);
    },

    handleAddRecord() {
      this.multiplierForm.name = "Add Multiplier"
      this.resetMultiplierForm()
      this.openMultiplierDialog();
    },

    async handleEditRecord(item) {
      this.multiplierForm.name = "Edit Multiplier"
      this.itemToUpdate = item;
      this.isLoadEditRecord = true;
     
      this.companySearch.data = item.m_companyID
        ? [{ db_val: item.m_companyID, val: item.companyName }]
        : [];
      
      this.multiplierForm.values = {
        year: this.yearOptions.find(opt => opt.val === item.m_year) || { db_val: item.m_year, val: item.m_year },
        month: this.monthOptions.find(opt => opt.val === item.m_month) || { db_val: item.m_month, val: item.m_month },
        mediaChannel: { db_val: item.m_mchannelID, val: item.mChannelName },
        company: { db_val: item.m_companyID, val: item.companyName },
        country: { db_val: item.m_countryID, val: item.countryName },
        multiplier: parseFloat(item.multiplier),
      };

      await this.openMultiplierDialog();

      this.multiplierForm.values = {
        ...JSON.parse(JSON.stringify(this.multiplierForm.values)),
        primarySector: { db_val: item.m_sectorID, val: item.s1_sectorName },
        primaryCategory: { db_val: item.m_categoryID, val: item.s2_sectorName },
        primarySubCategory: { db_val: item.m_subcategoryID, val: item.s3_sectorName }
      };

      requestAnimationFrame(()=>{
        const a = this.multiplierForm.values
        this.isLoadEditRecord = false;
      })  
    },

    async fetchCountries() {
      this.countryOptions.isLoading = true;
      try {
        const sectorsAndCatUrl = this.$url("admin_report_url") + "get_sectors_and_cat";

        const res = await this.$fetch({
          requiresAuth: true,
          operation: "add",
          vueScope: this
        }).post(sectorsAndCatUrl, {});

        this.countryOptions.data = res.data?.countries || [];
      } catch (error) {
        console.error(error);
      } finally {
        this.countryOptions.isLoading = false;
      }
    },
    
    async fetchAllSectors() {
      this.allSectors.isLoading = true;
      try {
        const sectorApi = this.$url("ALLSECTORS") + "?type=sector";
        const response = await this.$fetch({
          requiresAuth: true,
          operation: "view",
          vueScope: this,
        }).get(sectorApi);

        this.allSectors.data = response.data?.payload || [];
        this.sectorOptions.data = this.generateDropdownOptions(this.allSectors.data);
      } catch (error) {
        console.error(error);
      } finally {
        this.allSectors.isLoading = false;
      }
    },

    async fetchMediaChannels() {
      this.mediaChannelOptions.isLoading = true;
      try {
        const mediaChannelUrl = this.$url("admin_report_url") + "get_mchannel";
        const res = await this.$fetch({
          requiresAuth: true,
          operation: "add",
          vueScope: this
        }).post(mediaChannelUrl, {});

        if (res.data?.mChannelName?.length) {
          this.mediaChannelOptions.data = res.data.mChannelName;
        }
      } catch (error) {
        console.error(error);
      } finally {
        this.mediaChannelOptions.isLoading = false;
      }
    },
    validateMultiplierForm() {
      let res = this.$refs.form.validate();
      return res;
    },
    handleMultiplierFormSubmit() {
      if (this.multiplierForm.name == "Edit Multiplier") {
        this.updateRecord();
      } else {
        this.addRecord();
      }
    },
    async addRecord() {
      if (!this.validateMultiplierForm()) {
        return;
      }
      if (this.multiplierForm.isLoading || this.companySearch.isLoading || this.allSectors.isLoading) return;

      this.multiplierForm.isLoading = true;

      try {
        const insertUrl = this.$url("admin_report_url") + "insert_record";
        const formValues = this.multiplierForm.values;
        const data = {
          mChannelName: formValues.mediaChannel || {},
          companyName: formValues.company || {},
          countryName: formValues.country || {},
          m_month: formValues.month || {},
          m_year: formValues.year || {},
          multiplier: formValues.multiplier,
          s1_sectorName: formValues.primarySector || {},
          s2_sectorName: formValues.primaryCategory || {},
          s3_sectorName: formValues.primarySubCategory || {}
        };
        const res = await this.$fetch({
          requiresAuth: true,
          operation: "add",
          vueScope: this
        }).post(insertUrl, data);

        const { errCode, msg } = res.data;

        if (errCode === 0) {
          this.$swal.fire({
            icon: "success",
            title: "Record Inserted Successfully",
          });
          this.multiplierForm.isOpen = false;
          this.resetMultiplierForm();
          this.fetchReports();
        } else {
          if (msg?.includes("Duplicate entry")) {
            this.$swal.fire({
              icon: "error",
              title: "Duplicate entry",
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Some Error Occurred",
            });
          }
        }
      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Request failed",
        });
      } finally {
        this.multiplierForm.isLoading = false;
      }
    },
    
    async updateRecord() {
      if (!this.validateMultiplierForm()) {
        return;
      }
      if (this.multiplierForm.isLoading || this.companySearch.isLoading || this.allSectors.isLoading) return;
      this.multiplierForm.isLoading = true;
      
      try {
        const updateUrl = this.$url("admin_report_url") + "update_record";
        const formValues = this.multiplierForm.values;

        const data = {
          filters: this.itemToUpdate,
          data: {
            mChannelName: formValues.mediaChannel || {},
            companyName: formValues.company || {},
            countryName: formValues.country || {},
            m_month: formValues.month || {},
            m_year: formValues.year || {},
            multiplier: formValues.multiplier,
            s1_sectorName: formValues.primarySector || {},
            s2_sectorName: formValues.primaryCategory || {},
            s3_sectorName: formValues.primarySubCategory || {}
          }
        };

        const res = await this.$fetch({
          requiresAuth: true,
          operation: "edit",
          vueScope: this
        }).post(updateUrl, data);

        const { errCode, msg } = res.data;

        if (errCode === 0) {
          this.$swal.fire({
            icon: "success",
            title: "Record Updated Successfully",
          });

          this.multiplierForm.isOpen = false;
          this.resetMultiplierForm();
          this.fetchReports();
        } else {
          if (msg?.includes("Duplicate entry")) {
            this.$swal.fire({
              icon: "error",
              title: "Duplicate entry",
            });
          } else {
            this.$swal.fire({
              icon: "error",
              title: "Some Error Occurred",
            });
          }
        }

      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Request failed",
        });
      } finally {
        this.multiplierForm.isLoading = false;
      }
    },

    async deleteRecord() {
      this.isConfirmDeleteDialogOpen = false;
      if (this.isLoading) return;

      const deleteUrl = this.$url("admin_report_url") + "delete_record";
      const data = this.itemToDelete;
      this.multiplierForm.isLoading = true;

      try {
        const res = await this.$fetch({
          requiresAuth: true,
          operation: "delete",
          vueScope: this
        }).post(deleteUrl, data);

        if (res.data.errCode === 0) {
          this.$swal.fire({
            icon: "success",
            title: "Record Deleted Successfully",
          });
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Some Error Occurred",
          });
        }

        this.fetchReports();

      } catch (error) {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Request failed",
        });
      } finally {
        this.multiplierForm.isLoading = false;
      }
    },
    
    async fetchParticipations() {
      let direct_mail_part_url = this.$url("admin_report_url") + "direct_mail_participations";
      let email_part_url = this.$url("admin_report_url") + "email_participations";
      if (this.participationsTabItems[0].items.length > 0 && this.participationsTabItems[1].items.length){
        this.isParticipationsDialogOpen = true
        return
      }
      let direct_mail = []
      let electronic_mail = []
      const ranges = [
        [0, 3],
        [3, 6],
        [6, 9],
        [9, 12]
      ];
      this.isParticipationsLoading = true;
  
      // Use Promise.all with map for parallel requests
      const requests = ranges.map(async ([from, to]) => {
        const data = { from, to };
        
        // Run both API calls concurrently
        const [directMailRes, emailRes] = await Promise.all([
          this.$fetch({ requiresAuth: true, operation: "view", vueScope: this })
            .post(direct_mail_part_url, data),
          this.$fetch({ requiresAuth: true, operation: "view", vueScope: this })
            .post(email_part_url, data)
        ]);

        // Process responses
        if (directMailRes.data.errCode === 0) {
          direct_mail.push(...directMailRes.data.direct_mail);
        }
        if (emailRes.data.errCode === 0) {
          electronic_mail.push(...emailRes.data.electronic_mail);
        }
      });

      await Promise.all(requests);

      // Sort and assign data only if we have results
      if (direct_mail.length || electronic_mail.length) {
        const sortByDate = (a, b) => new Date(a.date) - new Date(b.date);
        
        direct_mail.sort(sortByDate);
        electronic_mail.sort(sortByDate);
        
        this.participationsTabItems[0].items = direct_mail;
        this.participationsTabItems[1].items = electronic_mail;
      }

      this.isParticipationsDialogOpen = true;
      this.isParticipationsLoading = false;
    },

    closeMultiplierDialog() {
      this.multiplierForm.isOpen = false;
    },

    handleDeleteRecord(item) {
      this.itemToDelete = item;
      this.isConfirmDeleteDialogOpen = true;
    },

    resetMultiplierForm(){
      this.multiplierForm.values = {
        year: {},
        month: {},
        mediaChannel: {},
        primarySector: {},
        primaryCategory: {},
        primarySubCategory: {},
        company: {},
        country: {},
        multiplier: 0.0,
      };
    },
    
    checkIfOperationExistForModule(type) {
      return this.$utils.checkIfOperationExistForModule(this, type);
    },
    
  },
  created() {
    this.fetchReports()
  },
};
</script>
